
const $592bfa78689b4fd4$var$menu = document.querySelector('#menu'); // hamburger
const $592bfa78689b4fd4$var$drawer = document.querySelector('#drawer');
const $592bfa78689b4fd4$var$main = document.querySelector('main');
// click on the hamburger menu to open and close nav drawer
$592bfa78689b4fd4$var$menu.addEventListener('click', (e)=>{
    $592bfa78689b4fd4$var$drawer.classList.toggle('open');
    $592bfa78689b4fd4$var$menu.classList.toggle('open');
    e.stopPropagation();
});
// click on main content area to close nav drawer
$592bfa78689b4fd4$var$main.addEventListener('click', ()=>{
    $592bfa78689b4fd4$var$drawer.classList.remove('open');
    $592bfa78689b4fd4$var$menu.classList.remove('open');
});


const $aaa482f3581ab212$var$aboutSection = document.querySelector('#about');
const $aaa482f3581ab212$var$aboutSectionYcoord = $aaa482f3581ab212$var$aboutSection.offsetTop;
// console.log(aboutSectionYcoord);
const $aaa482f3581ab212$var$header = document.querySelector('#header');
window.onscroll = function() {
    $aaa482f3581ab212$var$scrollFunction();
};
function $aaa482f3581ab212$var$scrollFunction() {
    // scrollY no IE support. pageYOffset IE 9 > support.
    // The read-only scrollY property of the Window interface returns the number of pixels that the document is currently scrolled vertically.
    /* at 400px before the about section, add or remove opacity: 0 and visibility: hidden  with .sticky class. so that .scrolling class can add opacity: 1 and visibility: visible. Triggered at 400px so the fade out is not abrupt. */ if ((typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY) > $aaa482f3581ab212$var$aboutSectionYcoord - 400) $aaa482f3581ab212$var$header.classList.add('sticky');
    else $aaa482f3581ab212$var$header.classList.remove('sticky');
    /* at 350px before the about section, add css transition property with .fade-transition class  */ if ((typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY) > $aaa482f3581ab212$var$aboutSectionYcoord - 350) $aaa482f3581ab212$var$header.classList.add('fade-transition');
    else $aaa482f3581ab212$var$header.classList.remove('fade-transition');
    /* at the about section, fade in the sticky nav opacity by adding .scrolling class */ if ((typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY) > $aaa482f3581ab212$var$aboutSectionYcoord - 50) $aaa482f3581ab212$var$header.classList.add('scrolling');
    else $aaa482f3581ab212$var$header.classList.remove('scrolling');
}


// Reference: https://www.youtube.com/watch?v=RsPWEmfOQdU&t=1170s&ab_channel=WEBCIFAR
const $d208c9e2293add47$var$sections = document.querySelectorAll('section');
const $d208c9e2293add47$var$navLi = document.querySelectorAll('nav ul li');
// console.log(navLi);
window.addEventListener('scroll', ()=>{
    console.log('pageYOffset: ' + window.pageYOffset);
    let current = '';
    $d208c9e2293add47$var$sections.forEach((section)=>{
        // get distance from top of page to the current section
        const sectionTop = section.offsetTop;
        console.log('sectionTop: ' + sectionTop);
        // get the height of each section
        const sectionHeight = section.clientHeight;
        console.log('section height: ' + sectionHeight);
        // if the distance scrolled is past a specified value, get the current sections's id
        // pageYOffset = returns the number of pixels the document is currently scrolled along the vertical axis (that is, up or down)
        if (pageYOffset >= sectionTop - sectionHeight / 25) current = section.getAttribute('id');
    });
    $d208c9e2293add47$var$navLi.forEach((li)=>{
        li.classList.remove('active');
        if (li.classList.contains(current)) li.classList.add('active');
    });
});




//# sourceMappingURL=repo.62a71234.js.map
